import React, { Component } from 'react'

class IcRightArrow extends Component {
  render() {
    const { width, height } = this.props
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 12 21"
      >
        <path
          fill="#DBDEE4"
          fillRule="evenodd"
          d="M11.226 10.976a1.166 1.166 0 0 0 0-1.676L1.891.174a.616.616 0 0 0-.857 0l-.857.837a.583.583 0 0 0 0 .838l8.05 7.87a.583.583 0 0 1 0 .838l-8.05 7.87a.583.583 0 0 0 0 .837l.857.838c.237.232.621.232.857 0l9.335-9.126z"
        />
      </svg>
    )
  }
}

export default IcRightArrow
